// extracted by mini-css-extract-plugin
export var SectionTitle = "SectionTitle-module--SectionTitle--IdH1Z";
export var Light = "SectionTitle-module--Light--Mh72z";
export var LangHY = "SectionTitle-module--LangHY--9Msn+";
export var arrowLeft = "SectionTitle-module--arrowLeft--jXqkU";
export var arrowRight = "SectionTitle-module--arrowRight--QYWuM";